export class LabelFotosLaudoscdModel {
  id: number;
  nome_pt: string;
  nome_en: string;
  nome_es: string;
  id_mercadoria: any = null;
  mercadoria?: any;
  mercadorias?: any[];
  ordem?: number;
}



// WEBPACK FOOTER //
// ./src/app/laudos-cd/label-fotos-laudoscd.model.ts